import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "input-father" }
const _hoisted_2 = { class: "input" }
const _hoisted_3 = ["readonly", "disabled", "value"]
const _hoisted_4 = {
  key: 0,
  class: "context-menu"
}
const _hoisted_5 = { class: "options-father" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "option-text" }
const _hoisted_8 = { class: "option-title" }
const _hoisted_9 = { class: "option-subtitle" }
const _hoisted_10 = {
  key: 1,
  class: "context-menu"
}
const _hoisted_11 = { class: "loader" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        readonly: $setup.isStatic(),
        onMouseover: _cache[0] || (_cache[0] = ($event: any) => ($setup.isHovered = true)),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => ($setup.isHovered = false)),
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.isFocused = true)),
        disabled: $setup.state == 'disabled',
        ref: "inputField",
        class: "common-input",
        "data-maska": '#####-###',
        onFocus: _cache[3] || (_cache[3] = ($event: any) => ($setup.isFocused = true)),
        value: $props.modelValue,
        style: _normalizeStyle({
          border: `1px solid var(--components-input-${$setup.getState()}-border-color, #CDC8D7)`,
          color: `var(--components-input-${$setup.state ?? 'default'}-text-color, #CDC8D7)`,
          fontWeight: `var(--components-input-${$setup.state}-font-weight, 800)`,
          borderTop: $setup.isFocused || $props.modelValue.length ? `none` : `1px solid var(--components-input-${$setup.getState()}-border-color, #CDC8D7)`,
          paddingRight: `calc(22px${$setup.props.type == 'password' ? ' + 22px' : ''}${$setup.thisInstance?.vnode?.props?.onTapTrailing ? ' + 22px' : ''})`,
        }),
        onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:model-value', ($event.target as HTMLInputElement).value))),
        onFocusout: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('leave-focus', ($event.target as HTMLInputElement).value))),
        onPaste: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$emit('on-paste', ($event)); $setup.timedSearchAddress()}),
        onKeydown: _cache[7] || (_cache[7] = ($event: any) => {
          if ($event.key === 'Enter' && $setup.options && $setup.options.length > 0) {
            _ctx.$emit('select', $setup.options[0]);
            $setup.isFocused = false;
            $setup.inputField?.blur();
          } else if ($event.key === 'Escape') {
            $setup.isFocused = false;
            $setup.inputField?.blur();
          } else {
            $setup.options = [];
            $setup.timedSearchAddress();
          }
        })
      }, null, 44 /* STYLE, PROPS, NEED_HYDRATION */, _hoisted_3), [
        [$setup["vMaska"]]
      ]),
      (($setup.isFocused || $props.modelValue.length) && $setup.labelElem)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref: "inputBefore",
            class: "input-before",
            style: _normalizeStyle({
        backgroundColor: `var(--components-input-${$setup.getState()}-border-color, #CDC8D7)`,
      })
          }, null, 4 /* STYLE */))
        : _createCommentVNode("v-if", true),
      (($setup.isFocused || $props.modelValue.length) && $setup.labelElem)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "input-after",
            style: _normalizeStyle({
        backgroundColor: `var(--components-input-${$setup.getState()}-border-color, #CDC8D7)`,
        width: `calc(100% - ${$setup.labelLeft}px - (var(--semantic-border-radius-default, 7px) * 2) - ${$setup.currentLabelSize}px)`,
      })
          }, null, 4 /* STYLE */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        ref: "labelElem",
        class: _normalizeClass([
          'semantic-typography-body-regular-default',
          'input-field-label',
          {
            'input-field-label-focused': $setup.floatOn,
            'semantic-typography-body-bold-small': $setup.floatOn
          }
        ]),
        style: _normalizeStyle({
          color: `var(--components-input-${$setup.getState()}-label-color, #6E6979)`,
          left: $setup.labelLeft,
        })
      }, [
        ($props.icon)
          ? (_openBlock(), _createBlock($setup["FontAwesomeIcon"], {
              key: 0,
              icon: $props.icon
            }, null, 8 /* PROPS */, ["icon"]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("p", null, _toDisplayString($props.label), 1 /* TEXT */)
      ], 6 /* CLASS, STYLE */),
      ($props.modelValue.length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            onMouseover: _cache[9] || (_cache[9] = ($event: any) => ($setup.isHovered = true)),
            class: "input-field-icons-container"
          }, [
            ($setup.thisInstance?.vnode?.props?.onTapTrailing)
              ? (_openBlock(), _createBlock($setup["FontAwesomeIcon"], {
                  key: 0,
                  icon: $props.iconButton ?? $setup.Icons.imported.faXmark,
                  class: "input-field-icon",
                  style: _normalizeStyle({
            color: `var(--components-input-${$setup.getState()}-right-icon-color, #6E6979)`,
          }),
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('tap-trailing', $event)))
                }, null, 8 /* PROPS */, ["icon", "style"]))
              : _createCommentVNode("v-if", true)
          ], 32 /* NEED_HYDRATION */))
        : _createCommentVNode("v-if", true)
    ]),
    ($setup.options!.length > 0)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.options, (option, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "option",
                onClick: ($event: any) => {_ctx.$emit('select', option); $setup.isFocused = false},
                key: index
              }, [
                _createVNode($setup["FontAwesomeIcon"], {
                  class: "option-icon",
                  icon: $setup.Icons.imported.faLocationDot
                }, null, 8 /* PROPS */, ["icon"]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString($setup.getOptionTitle(option)), 1 /* TEXT */),
                  _createElementVNode("p", _hoisted_9, _toDisplayString($setup.getOptionSubtitle(option)), 1 /* TEXT */)
                ])
              ], 8 /* PROPS */, _hoisted_6))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ], 512 /* NEED_PATCH */)), [
          [_vShow, $setup.isFocused && $setup.options!.length > 0]
        ])
      : ($setup.isLoading)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { style: {"height":"36px"} }, null, -1 /* HOISTED */)),
              _createVNode($setup["LoaderAnimation"], { ref: "loadingStep" }, null, 512 /* NEED_PATCH */),
              _cache[11] || (_cache[11] = _createElementVNode("div", { style: {"height":"36px"} }, null, -1 /* HOISTED */))
            ])
          ], 512 /* NEED_PATCH */)), [
            [_vShow, $setup.isFocused]
          ])
        : _createCommentVNode("v-if", true),
    ($props.supportingText)
      ? (_openBlock(), _createElementBlock("p", {
          key: 2,
          class: "supporting-text",
          style: _normalizeStyle(`color: var(--components-input-${$setup.getState()}-supporting-text-color)`)
        }, _toDisplayString($props.supportingText), 5 /* TEXT, STYLE */))
      : _createCommentVNode("v-if", true)
  ]))
}